import { createPinia } from 'pinia'

// 创建 Pinia 实例
const pinia = createPinia()

// 导出 Pinia 实例
export default pinia

// 重新导出 store 以便在全局使用
import { useUserStore } from './modules/user'
import { useAppStore } from './modules/app'
export { useUserStore, useAppStore }
